import React from 'react';
import { Star } from 'lucide-react';
export const BenefitsSection = () => {
  return <section className="w-full bg-white px-5 py-10" data-id="element-13">
      <div className="max-w-md mx-auto" data-id="element-14">
        <div className="border-b border-gray-200 w-full mb-10" data-id="element-15"></div>
        <BenefitBlock number={1} title="Floods Your Vagina With a Moisture-Balancing Probiotic" testimonial={{
        author: 'Melissa',
        text: "I was shocked. Within about a week and a half, the constant 'sandpaper' feeling was gone. I feel like myself again for the first time in years."
      }} stats={['Boosts beneficial bacteria by 89% ↑', 'Reduces odor-causing microbes ↓']} imageSrc="https://uploadthingy.s3.us-west-1.amazonaws.com/1bDwjKBTKMWMZz5cnryYPD/BENEFIT_1_PROBIOTIC_IMAGE.jpg" data-id="element-16">
          <p className="text-gray-700 mb-5 leading-relaxed" data-id="element-17">
            I'd tried generic probiotics before. They did nothing for my
            dryness, and sometimes I felt they made my digestion worse.
          </p>
          <p className="text-gray-700 mb-5 leading-relaxed" data-id="element-18">
            Nuora uses a specific, battle-tested strain that actually works:
          </p>
          <p className="text-gray-700 font-bold mb-2" data-id="element-19">
            Bacillus Coagulans 1969:
          </p>
          <p className="text-gray-700 mb-5 leading-relaxed" data-id="element-20">
            This powerful probiotic is tough enough to survive stomach acid and
            journey all the way to your vagina. There, it helps re-establish a
            healthy, moisture-friendly microbiome and pushes out the bad
            bacteria that thrive in dry conditions.
          </p>
          <p className="text-gray-700 font-bold mb-2" data-id="element-21">Why it matters:</p>
          <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-22">
            Most probiotics never reach the vagina. This one is clinically
            studied to colonize, restore balance, and create the foundation for
            natural moisture.
          </p>
          <Testimonial author="Marina J." text="I'm 55 and post-menopause had killed my intimate life. Zero confidence. Two weeks on these and everything's juicy again. My husband keeps asking if I found the fountain of youth!" data-id="element-23" />
          <Testimonial author="Samantha P." text="The odor I didn't even realize was from dryness is gone. I just feel... clean and normal. It's a huge weight off my shoulders." data-id="element-24" />
        </BenefitBlock>
        <BenefitBlock number={2} title="Rebuilds and Fortifies Your Vaginal Walls" imageSrc="https://uploadthingy.s3.us-west-1.amazonaws.com/6WQAP9PMQLLdgRYLwcqSxK/BENEFIT_2_VAGINAL_WALLS_IMAGE.jpg" data-id="element-25">
          <p className="text-gray-700 mb-5 leading-relaxed" data-id="element-26">
            I used to dread any kind of touch down there. Even sitting in jeans
            for too long was uncomfortable. Everything felt so fragile and thin.
          </p>
          <p className="text-gray-700 mb-5 leading-relaxed" data-id="element-27">
            Nuora's formula contains a key building block for resilient, healthy
            tissue:
          </p>
          <p className="text-gray-700 font-bold mb-2" data-id="element-28">Vitamin C:</p>
          <p className="text-gray-700 mb-5 leading-relaxed" data-id="element-29">
            This isn't just for colds. Vitamin C is crucial for collagen
            synthesis, which is what gives your vaginal walls their thickness,
            plumpness, and elasticity. It helps reverse the thinning that causes
            so much friction and pain.
          </p>
          <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-30">
            In fact, studies show that adequate Vitamin C intake is directly
            linked to improved vaginal tissue health and a reduction in
            recurring infections.
          </p>
          <Testimonial author="Mila R." text="This works! After 10 years of my husband being so gentle and cautious with me, he said, 'wow... you feel like you did when we were 20.' I could have cried with happiness." data-id="element-31" />
        </BenefitBlock>
        <BenefitBlock number={3} title="Reignites Your Body's Natural Lubrication Engine" imageSrc="https://uploadthingy.s3.us-west-1.amazonaws.com/mZF173mVKKNhZdWn1WWehp/BENEFIT_3_LUBRICATION_ENGINE_IMAGE.jpg" data-id="element-32">
          <p className="text-gray-700 mb-5 leading-relaxed" data-id="element-33">
            I was so tired of the passion-killing pause: "Wait, I have to go get
            the lube." It made me feel like a machine that needed oiling, not a
            woman.
          </p>
          <p className="text-gray-700 mb-5 leading-relaxed" data-id="element-34">
            Nuora's unique blend works with your body, not on it:
          </p>
          <p className="text-gray-700 font-bold mb-2" data-id="element-35">
            Pineapple Extract & Prebiotic Fiber:
          </p>
          <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-36">
            This combination does more than you think. Pineapple contains
            bromelain, an enzyme that supports overall freshness and a healthy
            taste. The prebiotic fiber feeds your good bacteria (the Bacillus
            Coagulans!), empowering them to create a perfectly balanced
            ecosystem where moisture can be naturally produced and maintained.
          </p>
          <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-37">
            This is how Nuora helps your body remember how to lubricate itself.
          </p>
          <Testimonial author="Jessica T." text="After my second baby, I was dry as a desert. I thought it was permanent. Three weeks into taking Nuora, I noticed I didn't need lube anymore. AT ALL. I feel like my old self is back." data-id="element-38" />
        </BenefitBlock>
        <BenefitBlock number={4} title="Soothes Chronic Inflammation & Irritation" stats={['Reduces daily irritation & micro-tears', "Soothes 'tight' feeling by 91%"]} testimonial={{
        author: 'Jan',
        text: "The burning and itching I thought was a permanent yeast infection (it wasn't) is completely gone. I can wear leggings again without wincing."
      }} imageSrc="https://uploadthingy.s3.us-west-1.amazonaws.com/sJ3VtfM6LFprdSsGQu4Qcm/BENEFIT_4_INFLAMMATION_IMAGE.jpg" data-id="element-39">
          <p className="text-gray-700 mb-5 leading-relaxed" data-id="element-40">
            That constant, low-grade feeling of irritation was exhausting. It
            felt like a tiny, internal sunburn that never healed.
          </p>
          <p className="text-gray-700 mb-5 leading-relaxed" data-id="element-41">
            Nuora tackles this inflammation at the source:
          </p>
          <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-42">
            By restoring the microbiome, rebuilding tissue, and balancing pH,
            Nuora eliminates the root causes of the inflammation. The soothing
            isn't a temporary masking effect—it's the result of true internal
            healing. Your body is no longer fighting itself.
          </p>
          <p className="text-gray-700 font-bold mb-6" data-id="element-43">
            The truth bomb: Chronic dryness IS chronic inflammation. You can't
            fix one without fixing the other.
          </p>
          <Testimonial author="Linda H, 58" text="For years, intimacy was something I endured, not enjoyed. Now, there's no pain. Just pleasure. It has totally changed my marriage." data-id="element-44" />
        </BenefitBlock>
        <BenefitBlock number={5} title="Rebuilds Total Intimate Confidence & Health" imageSrc="https://uploadthingy.s3.us-west-1.amazonaws.com/aa5RbqMaP7zzaBv1HWwHYw/BENEFIT_5_CONFIDENCE_IMAGE.png" data-id="element-45">
          <p className="text-gray-700 mb-5 leading-relaxed" data-id="element-46">
            I used to plan my entire day around my discomfort. What underwear to
            wear, avoiding the gym, worrying about travel. That mental load is
            finally gone.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-47">No more:</p>
          <ul className="list-disc pl-6 mb-6 space-y-3" data-id="element-48">
            <li className="text-gray-700" data-id="element-49">
              Painful friction from just walking or sitting
            </li>
            <li className="text-gray-700" data-id="element-50">
              Googling "why does intimacy hurt" at 2 AM
            </li>
            <li className="text-gray-700" data-id="element-51">
              Faking it because you're too embarrassed to say it hurts
            </li>
            <li className="text-gray-700" data-id="element-52">Feeling older than you are</li>
          </ul>
          <Testimonial author="Bea U." text="Everything you claim is true. Less dryness, yes! More desire, yes! No more discomfort! This is a game-changer." data-id="element-53" />
          <Testimonial author="Trudi, 49" text="My mood is better, my energy is better... I think the chronic discomfort was dragging me down more than I ever realized. My husband says he has his fun wife back!" data-id="element-54" />
        </BenefitBlock>
      </div>
    </section>;
};
interface BenefitBlockProps {
  number: number;
  title: string;
  children: React.ReactNode;
  testimonial?: {
    author: string;
    text: string;
  };
  stats?: string[];
  imageSrc?: string;
  placeholderName?: string;
}
const BenefitBlock = ({
  number,
  title,
  children,
  testimonial,
  stats,
  imageSrc,
  placeholderName
}: BenefitBlockProps) => {
  return <div className="mb-16" data-id="element-55">
      <h3 className="text-2xl font-bold text-pink-800 mb-5 leading-tight" data-id="element-56">
        {number}. {title}
      </h3>
      <div className="bg-pink-50 rounded-xl p-5 mb-7 shadow-sm" data-id="element-57">
        <div className="flex flex-col mb-5" data-id="element-58">
          {testimonial && <div className="bg-white rounded-xl p-4 shadow-sm mb-4 w-full" data-id="element-59">
              <div className="flex mb-2" data-id="element-60">
                {[1, 2, 3, 4, 5].map(n => <Star key={n} className="h-4 w-4 text-yellow-400 fill-yellow-400" data-id="element-61" />)}
              </div>
              <p className="text-base text-gray-700 italic mb-2 leading-relaxed" data-id="element-62">
                "{testimonial.text}"
              </p>
              <p className="text-sm font-semibold text-right mt-1 text-gray-600" data-id="element-63">
                - {testimonial.author}
              </p>
            </div>}
          {stats && <div className="flex flex-col w-full space-y-2 mb-4" data-id="element-64">
              {stats.map((stat, i) => <div key={i} className="bg-white rounded-xl p-3 shadow-sm" data-id="element-65">
                  <p className="text-sm font-semibold text-pink-800" data-id="element-66">{stat}</p>
                </div>)}
            </div>}
        </div>
        {imageSrc ? <div className="w-full rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-67">
            <img src={imageSrc} alt={`Nuora benefit: ${title}`} className="w-full h-auto max-w-full" data-id="element-68" />
          </div> : <div className="w-full h-48 bg-white rounded-xl shadow-sm mb-4 flex items-center justify-center" data-id="element-69">
            <p className="text-sm text-gray-400 font-medium" data-id="element-70">
              {placeholderName || '[Image placeholder]'}
            </p>
          </div>}
      </div>
      {children}
    </div>;
};
interface TestimonialProps {
  author: string;
  text: string;
}
const Testimonial = ({
  author,
  text
}: TestimonialProps) => {
  return <div className="bg-blue-50 rounded-xl p-5 mb-5 shadow-sm" data-id="element-71">
      <p className="text-gray-700 italic mb-3 leading-relaxed" data-id="element-72">💬 "{text}"</p>
      <p className="text-gray-700 font-semibold text-sm" data-id="element-73">– {author}</p>
    </div>;
};